/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReassignableReservation } from './ReassignableReservation';
import {
    ReassignableReservationFromJSON,
    ReassignableReservationFromJSONTyped,
    ReassignableReservationToJSON,
} from './ReassignableReservation';
import type { CancellableReservation } from './CancellableReservation';
import {
    CancellableReservationFromJSON,
    CancellableReservationFromJSONTyped,
    CancellableReservationToJSON,
} from './CancellableReservation';

/**
 * 
 * @export
 * @interface UnschedulePreviewResponse
 */
export interface UnschedulePreviewResponse {
    /**
     * 
     * @type {Array<CancellableReservation>}
     * @memberof UnschedulePreviewResponse
     */
    cancellableReservations: Array<CancellableReservation>;
    /**
     * 
     * @type {Array<ReassignableReservation>}
     * @memberof UnschedulePreviewResponse
     */
    reassignableReservations: Array<ReassignableReservation>;
}

/**
 * Check if a given object implements the UnschedulePreviewResponse interface.
 */
export function instanceOfUnschedulePreviewResponse(value: object): value is UnschedulePreviewResponse {
    if (!('cancellableReservations' in value) || value['cancellableReservations'] === undefined) return false;
    if (!('reassignableReservations' in value) || value['reassignableReservations'] === undefined) return false;
    return true;
}

export function UnschedulePreviewResponseFromJSON(json: any): UnschedulePreviewResponse {
    return UnschedulePreviewResponseFromJSONTyped(json, false);
}

export function UnschedulePreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnschedulePreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cancellableReservations': ((json['cancellableReservations'] as Array<any>).map(CancellableReservationFromJSON)),
        'reassignableReservations': ((json['reassignableReservations'] as Array<any>).map(ReassignableReservationFromJSON)),
    };
}

export function UnschedulePreviewResponseToJSON(value?: UnschedulePreviewResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cancellableReservations': ((value['cancellableReservations'] as Array<any>).map(CancellableReservationToJSON)),
        'reassignableReservations': ((value['reassignableReservations'] as Array<any>).map(ReassignableReservationToJSON)),
    };
}

